import html2canvas from "html2canvas";

export function getQueryParam(key) {
  if (!key) {
    return false;
  }

  var value = "";
  var paramStr = window.location.search ? window.location.search.substr(1) : "";

  if (paramStr) {
    paramStr.split("&").forEach(function(param) {
      var arr = param.split("=");
      if (arr[0] === key) {
        value = arr[1];
      }
    });
  }

  return value;
}
export function getScreenShots(docEle, options = {}, encoderOptions = 1) {
  return html2canvas(docEle, {
    ...options
  }).then(function(canvas) {
    canvas.style.display = "none";
    document.body.appendChild(canvas);
    let src = canvas.toDataURL("image/jpeg", encoderOptions);
    return src;
  });
}

export function guid() {
	function S4() {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	}
	return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
